import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress benign ResizeObserver loop error (Radix UI / browser race condition)
const resizeObserverErr = window.addEventListener('error', (e) => {
  if (e.message?.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
  }
});

// Register service worker for PWA with update toast
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      // Check for updates immediately and every 60s
      reg.update();
      setInterval(() => reg.update(), 60000);
      // When a new SW is found, show update toast instead of silent reload
      reg.addEventListener('updatefound', () => {
        const newWorker = reg.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New content available — dispatch event for App to show toast
              window.dispatchEvent(new CustomEvent('sw-update-available', { detail: { registration: reg } }));
            }
          });
        }
      });
    }).catch(() => {});
  });

  // Do not force a reload when a new service worker takes control.
  // App.js already offers an explicit, user-initiated refresh for updates.
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />,
);
